export const DEFAULT_LOCALE = process.env.REACT_APP_LOCALE ?? 'en-NZ';
export const GTM_ID = process.env.REACT_APP_GTM_ID ?? '';
export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK ?? '';
